<div class="mb-20" fxLayout fxLayoutAlign="flex-end">
  <button tabindex="-1" color="accent" (click)="htmlToPDF()" mat-raised-button>
    Download
  </button>
</div>
<section id="pdfDoc" class="card-wrapper" fxLayout="column" fxLayoutGap="2.5%">
  <div
    class="mb-30 ml-24"
    fxLayout="row"
    fxLayoutAlign="space-between"
    fxLayout.lt-lg="column"
    fxLayoutAlign.lt-lg="start"
    fxLayoutGap="2%"
  >
    <div fxFlex="45%" fxLayout fxLayoutAlign="start center">
      <img
        class="summaryIconClass"
        src="../../../../assets/heartcare_new_512.png"
        alt=""
      />
      <h1 class="mb-0">HeartCare</h1>
    </div>
    <div fxLayout="column" fxLayoutALign="center start">
      <p fxFlex="45%">
        Duration: <strong>{{ data?.duration }}</strong>
      </p>
      <p fxFlex="45%">
        Generated on: <strong>{{ dateStr }}</strong>
      </p>
      <p fxFlex="45%">
        Health Facility:
        <strong>{{ hospitalName + ', ' + levelTwoName }}</strong>
      </p>
    </div>
  </div>
  <mat-divider></mat-divider>

  <!-- // 1st ROW  -->

  <div fxFlex fxLayout fxLayoutGap="1.5%">
    <!-- // Tobacco users card  -->
    <mat-card fxFlex="48%" fxFlex.lt-lg="100%" fxLayout="column">
      <div class="mat-body-1 mb-20">
        TOTAL -
        <span class="fw500">{{ data?.tobaccoPatientsData.totalPatients }}</span>
      </div>
      <div
        class="primary-dark-text"
        fxLayout
        fxLayoutAlign="start flex-end"
        fxLayoutGap="10px"
      >
        <h3 fxFlex.lt-lg="15">
          {{ data?.tobaccoPatientsData.percentage | number: '1.0-0' }}%
        </h3>
        <h6>Tobacco Users</h6>
      </div>
      <div class="mt-10" fxLayout fxLayoutGap="35px">
        <div>
          <p>Daily</p>
          <div class="mat-body-1 mt-10">
            {{ data?.tobaccoPatientsData.totalNumber[0] }} Total
          </div>

          <div fxLayout fxLayoutGap="10px">
            <div fxLayout fxLayoutGap="5px">
              <h4>{{ data?.tobaccoPatientsData.maleNumber[0] }}</h4>
              <mat-icon class="man-ico">man</mat-icon>
            </div>
            <div fxLayout fxLayoutGap="5px">
              <h4>{{ data?.tobaccoPatientsData.femaleNumber[0] }}</h4>
              <mat-icon class="woman-ico">woman</mat-icon>
            </div>
          </div>
        </div>
        <div>
          <p>Sometimes</p>
          <div class="mat-body-1 mt-10">
            {{ data?.tobaccoPatientsData.totalNumber[1] }} Total
          </div>

          <div fxLayout fxLayoutGap="10px">
            <div fxLayout fxLayoutGap="5px">
              <h4>{{ data?.tobaccoPatientsData.maleNumber[1] }}</h4>
              <mat-icon class="man-ico">man</mat-icon>
            </div>
            <div fxLayout fxLayoutGap="5px">
              <h4>{{ data?.tobaccoPatientsData.femaleNumber[1] }}</h4>
              <mat-icon class="woman-ico">woman</mat-icon>
            </div>
          </div>
        </div>
        <div>
          <p>No</p>
          <div class="mat-body-1 mt-10">
            {{ data?.tobaccoPatientsData.totalNumber[2] }} Total
          </div>

          <div fxLayout fxLayoutGap="10px">
            <div fxLayout fxLayoutGap="5px">
              <h4>{{ data?.tobaccoPatientsData.maleNumber[2] }}</h4>
              <mat-icon class="man-ico">man</mat-icon>
            </div>
            <div fxLayout fxLayoutGap="5px">
              <h4>{{ data?.tobaccoPatientsData.femaleNumber[2] }}</h4>
              <mat-icon class="woman-ico">woman</mat-icon>
            </div>
          </div>
        </div>
      </div>
    </mat-card>

    <!-- // Tobacco users who were DVISED to quit card  -->
    <mat-card fxFlex="48%" fxFlex.lt-lg="100%" fxLayout="column">
      <div class="mat-body-1 mb-20">
        TOTAL -
        <span class="fw500">{{ data?.advisedToQuitData.totalPatients }}</span>
      </div>
      <div
        class="primary-dark-text"
        fxLayout
        fxLayoutAlign="start center"
        fxLayoutGap="10px"
        style="height: 20%"
      >
        <h3 fxFlex="33">
          {{ data?.advisedToQuitData.percentage | number: '1.0-0' }}%
        </h3>
        <h6 fxFlex="70">Tobacco users who were advised to quit</h6>
      </div>
      <div class="mt-10" fxLayout fxLayoutGap="30px">
        <div>
          <p>Yes</p>
          <div class="mat-body-1 mt-10">
            {{ data?.advisedToQuitData.totalNumber[0] }} Total
          </div>

          <div fxLayout fxLayoutGap="10px">
            <div fxLayout fxLayoutGap="5px">
              <h4>{{ data?.advisedToQuitData.maleNumber[0] }}</h4>
              <mat-icon class="man-ico">man</mat-icon>
            </div>
            <div fxLayout fxLayoutGap="5px">
              <h4>{{ data?.advisedToQuitData.femaleNumber[0] }}</h4>
              <mat-icon class="woman-ico">woman</mat-icon>
            </div>
          </div>
        </div>
        <div>
          <p>No</p>
          <div class="mat-body-1 mt-10">
            {{ data?.advisedToQuitData.totalNumber[1] }} Total
          </div>

          <div fxLayout fxLayoutGap="10px">
            <div fxLayout fxLayoutGap="5px">
              <h4>{{ data?.advisedToQuitData.maleNumber[1] }}</h4>
              <mat-icon class="man-ico">man</mat-icon>
            </div>
            <div fxLayout fxLayoutGap="5px">
              <h4>{{ data?.advisedToQuitData.femaleNumber[1] }}</h4>
              <mat-icon class="woman-ico">woman</mat-icon>
            </div>
          </div>
        </div>
      </div>
    </mat-card>
  </div>

  <mat-divider></mat-divider>

  <!-- // 2nd  ROW  -->

  <div fxFlex fxLayout fxLayoutGap="1.5%">
    <!-- // Tobacco users who were ready to quit card  -->
    <mat-card fxFlex="48%" fxFlex.lt-lg="100%" fxLayout="column">
      <div class="mat-body-1 mb-20">
        TOTAL -
        <span class="fw500">{{ data?.readyToQuitData.totalPatients }}</span>
      </div>
      <div
        class="primary-dark-text"
        fxLayout
        fxLayoutAlign="start center"
        fxLayoutGap="10px"
        style="height: 20%"
      >
        <h3 fxFlex.lt-lg="15">
          {{ data?.readyToQuitData.percentage | number: '1.0-0' }}%
        </h3>
        <h6>Tobacco users who were ready to quit</h6>
      </div>
      <div class="mt-10" fxLayout fxLayoutGap="30px">
        <div>
          <p>Yes</p>
          <div class="mat-body-1 mt-10">
            {{ data?.readyToQuitData.totalNumber[0] }} Total
          </div>

          <div fxLayout fxLayoutGap="10px">
            <div fxLayout fxLayoutGap="5px">
              <h4>{{ data?.readyToQuitData.maleNumber[0] }}</h4>
              <mat-icon class="man-ico">man</mat-icon>
            </div>
            <div fxLayout fxLayoutGap="5px">
              <h4>{{ data?.readyToQuitData.femaleNumber[0] }}</h4>
              <mat-icon class="woman-ico">woman</mat-icon>
            </div>
          </div>
        </div>
        <div>
          <p>No</p>
          <div class="mat-body-1 mt-10">
            {{ data?.readyToQuitData.totalNumber[1] }} Total
          </div>

          <div fxLayout fxLayoutGap="10px">
            <div fxLayout fxLayoutGap="5px">
              <h4>{{ data?.readyToQuitData.maleNumber[1] }}</h4>
              <mat-icon class="man-ico">man</mat-icon>
            </div>
            <div fxLayout fxLayoutGap="5px">
              <h4>{{ data?.readyToQuitData.femaleNumber[1] }}</h4>
              <mat-icon class="woman-ico">woman</mat-icon>
            </div>
          </div>
        </div>
      </div>
    </mat-card>
    <!-- // Tobacco users who developed a quit plan with HCP card  -->
    <mat-card fxFlex="48%" fxFlex.lt-lg="100%" fxLayout="column">
      <div class="mat-body-1 mb-20">
        TOTAL -
        <span class="fw500">{{
          data?.hcpPatientsData.registeredPatients
        }}</span>
      </div>
      <div
        class="primary-dark-text"
        fxLayout
        fxLayoutAlign="start center"
        fxLayoutGap="10px"
        style="height: 20%"
      >
        <h3 fxFlex.lt-lg="15">
          {{ data?.hcpPatientsData.percentage | number: '1.0-0' }}%
        </h3>
        <h6>Tobacco users who developed a quit plan with HCP</h6>
      </div>
      <div class="mt-10" fxLayout fxLayoutGap="30px">
        <div>
          <p>Yes</p>
          <div class="mat-body-1 mt-10">
            {{ data?.hcpPatientsData.totalNumber }} Total
          </div>

          <div fxLayout fxLayoutGap="10px">
            <div fxLayout fxLayoutGap="5px">
              <h4>{{ data?.hcpPatientsData.maleNumber }}</h4>
              <mat-icon class="man-ico">man</mat-icon>
            </div>
            <div fxLayout fxLayoutGap="5px">
              <h4>{{ data?.hcpPatientsData.femaleNumber }}</h4>
              <mat-icon class="woman-ico">woman</mat-icon>
            </div>
          </div>
        </div>
      </div>
    </mat-card>
  </div>

  <mat-divider></mat-divider>

  <!-- // 3rd  ROW  -->

  <div fxFlex fxLayout fxLayoutGap="1.5%">
    <!-- // Tobacco users who were referred by HCP to intensive counselling card  -->
    <mat-card fxFlex="48%" fxFlex.lt-lg="100%" fxLayout="column">
      <div class="mat-body-1 mb-20">
        TOTAL -
        <span class="fw500">{{
          data?.hcpToIntensiveData.registeredPatients
        }}</span>
      </div>
      <div
        class="primary-dark-text"
        fxLayout
        fxLayoutAlign="start center"
        fxLayoutGap="10px"
        style="height: 20%"
      >
        <h3 fxFlex.lt-lg="15">
          {{ data?.hcpToIntensiveData.percentage | number: '1.0-0' }}%
        </h3>
        <h6>Tobacco users who were referred by HCP to intensive counselling</h6>
      </div>
      <div class="mt-10" fxLayout fxLayoutGap="30px">
        <div>
          <p>Yes</p>
          <div class="mat-body-1 mt-10">
            {{ data?.hcpToIntensiveData.totalNumber }} Total
          </div>

          <div fxLayout fxLayoutGap="10px">
            <div fxLayout fxLayoutGap="5px">
              <h4>{{ data?.hcpToIntensiveData.maleNumber }}</h4>
              <mat-icon class="man-ico">man</mat-icon>
            </div>
            <div fxLayout fxLayoutGap="5px">
              <h4>{{ data?.hcpToIntensiveData.femaleNumber }}</h4>
              <mat-icon class="woman-ico">woman</mat-icon>
            </div>
          </div>
        </div>
      </div>
    </mat-card>

    <!-- // Tobacco users who developed a quit plan and prescribed NRTs card  -->
    <mat-card fxFlex="48%" fxFlex.lt-lg="100%" fxLayout="column">
      <div class="mat-body-1 mb-20">
        TOTAL -
        <span class="fw500">{{
          data?.prescribedNrtsData.registeredPatients
        }}</span>
      </div>
      <div
        class="primary-dark-text"
        fxLayout
        fxLayoutAlign="start center"
        fxLayoutGap="10px"
        style="height: 20%"
      >
        <h3 fxFlex.lt-lg="15">
          {{ data?.prescribedNrtsData.percentage | number: '1.0-0' }}%
        </h3>
        <h6>Tobacco users who developed a quit plan and prescribed NRTs</h6>
      </div>
      <div class="mt-10" fxLayout fxLayoutGap="30px">
        <div>
          <p>Yes</p>
          <div class="mat-body-1 mt-10">
            {{ data?.prescribedNrtsData.totalNumber }} Total
          </div>

          <div fxLayout fxLayoutGap="10px">
            <div fxLayout fxLayoutGap="5px">
              <h4>{{ data?.prescribedNrtsData.maleNumber }}</h4>
              <mat-icon class="man-ico">man</mat-icon>
            </div>
            <div fxLayout fxLayoutGap="5px">
              <h4>{{ data?.prescribedNrtsData.femaleNumber }}</h4>
              <mat-icon class="woman-ico">woman</mat-icon>
            </div>
          </div>
        </div>
      </div>
    </mat-card>
  </div>

  <mat-divider></mat-divider>

  <!-- ================================== // 4th ROw ================================== -->
  <div
    fxLayout
    fxLayoutAlign="stretch stretch"
    fxLayout.lt-lg="column"
    fxLayoutAlign.lt-lg="start stretch"
    fxLayoutGap="1.5%"
  >
    <!-- // Intensive counselling & NRT card  -->
    <mat-card fxFlex="100%" fxFlex.lt-lg="100%" fxLayout="column">
      <div
        class="primary-dark-text"
        fxLayout
        fxLayoutAlign="start start"
        fxLayoutGap="10px"
      >
        <div fxFlex fxLayoutGap="30px" fxLayout="column">
          <div fxLayout fxLayoutAlign="start center" fxLayoutGap="10px">
            <h3 fxFlex="9" fxFlex.lt-lg="15">
              {{
                data?.tobaccoFreeData ? data?.tobaccoFreeData.overallCount : ''
              }}
            </h3>
            <div fxFlex fxLayoutGap="5px" fxLayout="column">
              <h6>Tobacco-free in 6 months</h6>
              <h5>
                Split by intensive counselling & NRT (Nicotine replacement
                therapy)
              </h5>
            </div>
          </div>

          <div fxLayout="column" fxLayoutGap="-4px">
            <div
              fxFlex
              fxLayout="row"
              fxLayoutGap="10px"
              fxFlexAlign="start center"
            >
              <div><mat-icon style="color: #5cbdfc">square</mat-icon></div>
              <p>
                {{
                  data?.tobaccoFreeData
                    ? data?.tobaccoFreeData.noReferralToIntensive[0].totalNumber
                    : ''
                }}
                without referral to counselling
              </p>
            </div>

            <div
              fxFlex
              fxLayout="row"
              fxLayoutGap="10px"
              fxFlexAlign="start center"
            >
              <div><mat-icon style="color: #006098">square</mat-icon></div>
              <p>
                {{
                  data?.tobaccoFreeData
                    ? data?.tobaccoFreeData.referralToIntensive[0].totalNumber
                    : ''
                }}
                referred but not offered NRT
              </p>
            </div>

            <div
              fxFlex
              fxLayout="row"
              fxLayoutGap="10px"
              fxFlexAlign="start center"
            >
              <div><mat-icon style="color: #d86422">square</mat-icon></div>
              <p>
                {{
                  data?.tobaccoFreeData
                    ? data?.tobaccoFreeData.referralWithNrt[0].totalNumber
                    : ''
                }}
                referred and offered NRT
              </p>
            </div>
          </div>
        </div>

        <!-- Chart -->
        <div style="position: relative; top: -10px">
          <canvas width="200" height="200" #pieChartMain id="myPieChart">
          </canvas>
        </div>
      </div>
      <div>
        <!-- ====================     Split by gender table ===============  -->
        <mat-divider></mat-divider>
        <br />
        <div>
          <h6 fxFlex="100" class="primary-dark-text">SPLIT BY GENDER</h6>
        </div>
        <!-- ====================     Split by gender table ===============  -->
        <div *ngIf="showSplitByGender" class="mt-10">
          <div
            fxLayout="row"
            fxLayoutGap="70px"
            fxLayoutAlign="start flex-end"
          >
            <!-- Headers -->
            <div fxLayout="column" fxLayoutGap="20px" class="ageGroup">
              <span style="color: rgba(0, 0, 0, 0.8)">Total</span>
              <mat-icon class="man-ico">man</mat-icon>
              <mat-icon class="woman-ico">woman</mat-icon>
            </div>

            <!-- No referral -->
            <div
              fxLayout="column"
              fxLayoutGap="20px"
              fxLayoutAlign="center center"
              class="columnHeaders"
            >
              <span style="color: rgba(0, 0, 0, 0.8)">No referral</span>
              <div>
                {{
                  data?.tobaccoFreeData
                    ? data?.tobaccoFreeData.noReferralToIntensive[0].totalNumber
                    : ''
                }}
              </div>
              <div>
                {{
                  data?.tobaccoFreeData
                    ? data?.tobaccoFreeData.noReferralToIntensive[0].maleNumber
                    : ''
                }}
              </div>
              <div>
                {{
                  data?.tobaccoFreeData
                    ? data?.tobaccoFreeData.noReferralToIntensive[0].femaleNumber
                    : ''
                }}
              </div>
            </div>

            <div
              fxLayout="column"
              fxLayoutGap="20px"
              fxLayoutAlign="center center"
              class="columnHeaders"
            >
              <span style="color: rgba(0, 0, 0, 0.8)">Referred</span>
              <div>
                {{
                  data?.tobaccoFreeData
                    ? data?.tobaccoFreeData.referralToIntensive[0].totalNumber
                    : ''
                }}
              </div>
              <div>
                {{
                  data?.tobaccoFreeData
                    ? data?.tobaccoFreeData.referralToIntensive[0].maleNumber
                    : ''
                }}
              </div>
              <div>
                {{
                  data?.tobaccoFreeData
                    ? data?.tobaccoFreeData.referralToIntensive[0].femaleNumber
                    : ''
                }}
              </div>
            </div>

            <div
              fxLayout="column"
              fxLayoutGap="20px"
              fxLayoutAlign="center center"
              class="columnHeaders"
            >
              <span style="color: rgba(0, 0, 0, 0.8)">Referred + NRT</span>
              <div>
                {{
                  data?.tobaccoFreeData
                    ? data?.tobaccoFreeData.referralWithNrt[0].totalNumber
                    : ''
                }}
              </div>
              <div>
                {{
                  data?.tobaccoFreeData
                    ? data?.tobaccoFreeData.referralWithNrt[0].maleNumber
                    : ''
                }}
              </div>
              <div>
                {{
                  data?.tobaccoFreeData
                    ? data?.tobaccoFreeData.referralWithNrt[0].femaleNumber
                    : ''
                }}
              </div>
            </div>

            <div
              fxLayout="column"
              fxLayoutGap="20px"
              fxLayoutAlign="center center"
              class="columnHeaders"
            >
              <span style="color: rgba(0, 0, 0, 0.8)">Total</span>
              <!-- <p *ngFor="let item of tobaccoFreeData.femaleList">{{ item }}</p> -->
              <div>
                {{
                  data?.tobaccoFreeData.noReferralToIntensive[0].totalNumber +
                    data?.tobaccoFreeData.referralToIntensive[0].totalNumber +
                    data?.tobaccoFreeData.referralWithNrt[0].totalNumber
                }}
              </div>
              <div>
                {{
                  data?.tobaccoFreeData
                    ? data?.tobaccoFreeData.noReferralToIntensive[0].maleNumber +
                      data?.tobaccoFreeData.referralToIntensive[0].maleNumber +
                      data?.tobaccoFreeData.referralWithNrt[0].maleNumber
                    : ''
                }}
              </div>
              <div>
                {{
                  data?.tobaccoFreeData
                    ? data?.tobaccoFreeData.noReferralToIntensive[0].femaleNumber +
                      data?.tobaccoFreeData.referralToIntensive[0].femaleNumber +
                      data?.tobaccoFreeData.referralWithNrt[0].femaleNumber
                    : ''
                }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </mat-card>
  </div>
  <mat-divider></mat-divider>
</section>
